import React, { Fragment } from 'react';
import Spinner from 'react-spinkit';
import { useTheme, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  loading: {
    Webkitdisplay: 'flex',
    display: 'flex',
    WebkitFlex: '0 1 auto',
    flex: '0 1 auto',
    WebkitFlexDirection: 'column',
    flexDirection: 'column',
    WebkitFlexGrow: 1,
    flexGrow: 1,
    WebkitFlexShrink: 0,
    flexShrink: 0,
    height: '200px',
    WebkitAlignItems: 'center',
    alignItems: 'center',
    WebkitJustifyContent: 'center',
    justifyContent: 'center',
  },
}));

const Loading = () => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Fragment>
      <div className={classes.loading}>
        <Spinner name="line-scale" color={theme.palette.primary.main} />
      </div>
    </Fragment>
  );
};

export default Loading;
